
    import { Component, Mixins } from 'vue-property-decorator';
    import Footer from '@rogues/Footer/shared/footer';
    import { YContactInfo } from '@rogues/ContactInfo';

    @Component({
        components: {
            YContactInfo,
        },
    })
    /**
     * @name Summary
     */
    export default class Summary extends Mixins(Footer) {
        /**
         * settings types
         */
        $settings!: Function;
        
        /**
         * Return location object
         * 
         * @returns {object | null}
         */
        get location() {
            return this.$settings(`contact_details.elements.0.location.${this.$i18n.locale}`);
        }
    }
